export type ConfigurationValue = number | boolean | string;

export class ConfigurationItem {
  key: string;
  value: ConfigurationValue;
  groupKey: string;
  selectItems: SelectItem[];

  constructor(key: string, value: ConfigurationValue, groupKey: string, selectItems: SelectItem[]) {
    this.key = key;
    this.value = value;
    this.groupKey = groupKey;
    this.selectItems = selectItems;
  }
}

export class SelectItem {
  label: string;
  value: ConfigurationValue;
}
